<template>
  <jczh-drawer
    :visible.sync="visible"
    title="申请开票"
    confirm-button-text="提交发票申请"
    size="600px"
    @close="close"
    @confirm="confirmApply"
  >
    <template v-slot:content>
      <el-form
        class="m-t-10"
        label-suffix="："
        size="small"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="选择发票类型">
          <el-radio-group v-model="invoiceType">
            <el-radio
              v-for="item in invoiceTypeDict.dictArray"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <general-invoice
        v-if="inGeneralInvoice"
        ref="generalInvoice"
        class="invoice-wrapper m-t-20"
        :company-id="companyId"
        :is-employee="Boolean(companyId)"
        @getInvoiceInfo="getInvoiceInfo"
        @toInvoiceHelp="toInvoiceHelp"
      />

      <special-invoice
        v-else
        ref="specialInvoice"
        class="m-t-20"
        :company-id="companyId"
        :is-employee="Boolean(companyId)"
        @getInvoiceInfo="getInvoiceInfo"
        @toInvoiceHelp="toInvoiceHelp"
      />
    </template>
  </jczh-drawer>
</template>

<script>
import GeneralInvoice from '@/components/guarantee/GeneralInvoice.vue'
import SpecialInvoice from '@/components/guarantee/SpecialInvoice.vue'
import {
  invoiceApplyTypeDict,
  invoiceTitleTypeDict,
  invoiceTypeDict
} from '@/dictionary/financial'

/**
 * 申请开票
 */
export default {
  name: 'ApplyInvoice',

  components: { GeneralInvoice, SpecialInvoice },

  props: {
    companyId: {
      type: [String, Number],
      required: true
    },

    amount: {
      type: Number,
      default: 0
    },

    // 实付金额(用于判断是否可以开专票)
    accountBalance: {
      type: Number,
      default: 0
    },

    // 收费类型
    chargeType: {
      type: [Number, String],
      default: ''
    },

    // 开票类别
    applyType: {
      type: [Number, String],
      default: invoiceApplyTypeDict.SINGLE_APPLY.value
    },

    onConfirm: {
      type: Function,
      default: () => new Promise()
    }
  },

  data() {
    return {
      invoiceTypeDict,

      visible: false,

      invoiceType: invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value,
      invoiceInfo: {},
      // 发票抬头
      invoiceTitle: invoiceTitleTypeDict.COMPANY.value
    }
  },

  computed: {
    // 选择普通发票
    inGeneralInvoice() {
      return (
        this.invoiceType === invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value
      )
    }
  },

  methods: {
    open() {
      this.visible = true
    },

    close() {
      this.visible = false
    },

    getInvoiceInfo(info) {
      this.invoiceInfo = info
    },

    confirmApply() {
      if (!this.invoiceInfo.id) {
        this.$systemConfirm('请先完善开票信息', '系统提示', '立即前往').then(
          bool => {
            if (!bool) return

            this.toInvoiceHelp()
          }
        )
        return
      }

      this.onConfirm(this.invoiceInfo).then(() => {
        this.close()
      })
    },

    toInvoiceHelp() {
      const url =
        process.env.VUE_APP_PASSPORT_URL +
        '/personal-center/invoice/helper' +
        '?returnUrl=${encodeURIComponent(window.location.href)}'
      window.open(url, '_self')
    }
  }
}
</script>

<style scoped lang="scss"></style>
